import { __assign, __generator, __spreadArrays } from "tslib";
import { all, select, put, call, takeLatest, takeEvery, delay, } from 'redux-saga/effects';
import { withOffset, selectors } from '../../Stream';
import { actions as notificationActions, NotificationType, } from '../../Notifications';
import { getCurrentUserId, getIsLoggedIn } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { FolderType, } from './types';
import { getFolderStreamId, getGroupsStreamId } from './helpers';
import { addToGroupFolderFail, addToGroupFolderSuccess, addToGroupFolder, initGroupsPanel, } from './actions';
import { hidePanel } from '../../DeviationPage/redux/actions';
import { normalize } from 'normalizr';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { putEntities } from '../../redux/entities/actions';
import { groupFoldersStreamType, groupsStreamType } from './constants';
import { fetchGroupFolders, fetchGroups, addDeviationToGroupFolder, } from './xhr';
import { BiEventType, ReferralType } from '../../biLogger';
import { ResourceType } from '../../types/resource';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getPageBiContext } from '../../biLogger/redux/selectors';
function handleFetch(_a) {
    var streamParams, _b;
    var streamId = _a.streamId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 1:
                streamParams = _c.sent();
                if (!streamParams) {
                    return [2 /*return*/];
                }
                _b = streamParams.type;
                switch (_b) {
                    case groupsStreamType: return [3 /*break*/, 2];
                    case groupFoldersStreamType: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, call(handleFetchGroups, streamId, streamParams)];
            case 3:
                _c.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(handleFetchFolders, streamId, streamParams)];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function handleFetchFolders(streamId, streamParams) {
    var isLoggedIn, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, delay(300)];
            case 4:
                _a.sent();
                return [4 /*yield*/, call(fetchGroupFolders, streamParams.groupId, streamParams.folderType)];
            case 5:
                result = _a.sent();
                if (!!result) return [3 /*break*/, 7];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch folders',
                    }))];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7: return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                    streamId: streamId,
                    dedupeFunction: function (item, existingItems) {
                        return !existingItems.some(function (i) { return i.folderId === item.folderId; });
                    },
                    items: result.results,
                    hasMore: false,
                }))];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleFetchGroups(streamId, streamParams) {
    var isLoggedIn, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, delay(300)];
            case 4:
                _a.sent();
                return [4 /*yield*/, call(fetchGroups)];
            case 5:
                result = _a.sent();
                if (!!result) return [3 /*break*/, 7];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch groups',
                    }))];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7: 
            // update groups stream, and init folder streams for all fetched groups
            return [4 /*yield*/, all(__spreadArrays([
                    put(withOffset.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        dedupeFunction: function (item, existingItems) {
                            return !existingItems.some(function (i) { return i.userId === item.userId; });
                        },
                        items: result.results,
                        hasMore: false,
                    }))
                ], result.results
                    .map(function (group) {
                    return [FolderType.Gallery, FolderType.Collection].map(function (folderType) {
                        var folderStreamId = getFolderStreamId(folderType, group.userId);
                        var folderStreamParams = {
                            type: groupFoldersStreamType,
                            folderType: folderType,
                            userId: streamParams.userId,
                            groupId: group.userId,
                        };
                        return put(withOffset.actions.initialize({
                            streamId: folderStreamId,
                            itemsPerFetch: 24,
                            items: [],
                            hasMore: true,
                            streamParams: folderStreamParams,
                        }));
                    });
                })
                    .reduce(function (flattened, current) { return __spreadArrays(flattened, current); }, [])))];
            case 8:
                // update groups stream, and init folder streams for all fetched groups
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleAddToGroup(_a) {
    var isLoggedIn, biContext, result, notification, updatedDeviation, entities;
    var _b = _a.payload, group = _b.group, deviation = _b.deviation, groupFolderId = _b.groupFolderId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                return [4 /*yield*/, select(getPageBiContext)];
            case 2:
                biContext = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 4];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, call(addDeviationToGroupFolder, groupFolderId, deviation.deviationId)];
            case 5:
                result = _c.sent();
                notification = {
                    success: result.success,
                    needsVote: result.needsVote,
                    deviation: deviation,
                    group: group,
                    groupFolderId: groupFolderId,
                };
                if (!!result.success) return [3 /*break*/, 7];
                return [4 /*yield*/, put(addToGroupFolderFail(deviation.deviationId, groupFolderId))];
            case 6:
                _c.sent();
                return [3 /*break*/, 10];
            case 7: return [4 /*yield*/, put(addToGroupFolderSuccess(deviation.deviationId, groupFolderId, !!result.needsVote))];
            case 8:
                _c.sent();
                if (!(!result.needsVote &&
                    typeof result.deviationGroupCount !== undefined &&
                    deviation.extended &&
                    deviation.extended.stats)) return [3 /*break*/, 10];
                updatedDeviation = __assign(__assign({}, deviation), { extended: __assign(__assign({}, deviation.extended), { stats: __assign(__assign({}, deviation.extended.stats), { groups: deviation.extended.stats.groups + 1 }) }) });
                entities = normalize(updatedDeviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities(entities))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [4 /*yield*/, delay(1000)];
            case 11:
                _c.sent();
                return [4 /*yield*/, put(hidePanel('groups'))];
            case 12:
                _c.sent();
                return [4 /*yield*/, call(logBiEvent, __assign(__assign({}, biContext), { evid: BiEventType.ADD_TO_GROUP_FOLDER_SELECT, deviationid: deviation.deviationId, groupid: group.useridUuid, typeid: groupFolderId.type === FolderType.Collection
                            ? ResourceType.COLLECTION
                            : ResourceType.GALLERY, itemid: groupFolderId.folderId }))];
            case 13:
                _c.sent();
                return [4 /*yield*/, put(notificationActions.addNotification(NotificationType.AddToGroup, notification))];
            case 14:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
function handleInit() {
    var isLoggedIn, streamId, userId, existingStreamParams, streamParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!isLoggedIn) {
                    return [2 /*return*/];
                }
                streamId = getGroupsStreamId();
                return [4 /*yield*/, select(getCurrentUserId)];
            case 2:
                userId = _a.sent();
                return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 3:
                existingStreamParams = _a.sent();
                if (existingStreamParams && existingStreamParams.userId === userId) {
                    // already initialized, we're good
                    return [2 /*return*/];
                }
                streamParams = {
                    type: groupsStreamType,
                    userId: userId,
                };
                return [4 /*yield*/, put(withOffset.actions.initialize({
                        streamId: streamId,
                        itemsPerFetch: 24,
                        items: [],
                        hasMore: true,
                        streamParams: streamParams,
                    }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(withOffset.actions.fetch(streamId))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default function groupsRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initGroupsPanel, handleInit),
                    takeEvery(withOffset.actions.STREAM__WITH_OFFSET__FETCH, handleFetch),
                    takeLatest(addToGroupFolder, handleAddToGroup),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map